import * as React from 'react'
import { ReactElement } from 'react'
const SvgDownLeftArrow = (props: any): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={12} fill="none" {...props}>
    <path
      fill="#0088DC"
      fillRule="evenodd"
      d="M.921 11.996c.03.003.06.004.09.004h9c.55 0 1-.45 1-.998 0-.56-.45-.999-1-.999h-6.6l8.3-8.287c.39-.4.39-1.028 0-1.417a.992.992 0 0 0-1.42 0l-8.28 8.266V2.017c0-.56-.45-.999-1-.999-.56 0-1 .44-1 .999v8.827a.994.994 0 0 0 .29.867 1.002 1.002 0 0 0 .62.286Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgDownLeftArrow
